import { anim, pv, stagger } from '../../../motion'
import { Shape } from '../../../primitives'
import { Line, Words } from '../../../v2/kit'
import { useCopy } from '../../i18n'

const LOOK = [
  { kind: 'sq', color: 'blue', tint: '#EEF2FE' },
  { kind: 'dot', color: 'green', tint: '#E3F8F6' },
  { kind: 'tri', color: 'yellow', tint: '#FFF4DE' },
  { kind: 'sq', color: 'pink', tint: '#FFE9F1' }
]

// Spotlight je Perspektive, danach stehen alle vier wieder gemeinsam
const START = 0.24
const SPAN = 0.165
const spot = (i) => [START + i * SPAN, START + (i + 1) * SPAN]

export default function DemoPerspectives() {
  const c = useCopy('perspektiven')

  return (
    <div className='cin-pad cin-pad--top'>
      <div className='cin-head dm-persp-head'>
        <Line at={[0, 0.06]} className='cin-eyebrow'>
          {c.eyebrow}
        </Line>
        <h2 className='cin-title'>
          <Words text={c.title} at={[0.02, 0.12]} />
        </h2>
        <Line at={[0.1, 0.16]} y={16} className='dm-sub'>
          {c.sub}
        </Line>
      </div>

      <div className='dm-persp'>
        {c.groups.map((g, i) => {
          const [a, b] = spot(i)
          const look = LOOK[i]
          return (
            <div
              key={g.title}
              className='dm-persp__cell'
              style={anim({ at: stagger(0.08, 0.03, 0.08, i), y: 60, s: 0.94 })}
            >
              <article
                className='dm-tile'
                style={{
                  ...pv('a', [START - 0.02, START + 0.01]),
                  ...pv('f', [a, a + 0.03]),
                  ...pv('g', [b - 0.02, b]),
                  ...pv('z', [0.9, 0.94]),
                  '--tint': look.tint
                }}
              >
                <div className='dm-tile__top'>
                  <Shape kind={look.kind} color={look.color} size={28} />
                  <span className='dm-tile__tag'>{g.tag}</span>
                </div>
                <h3 className='dm-tile__title'>{g.title}</h3>
                <p className='dm-tile__question'>{g.question}</p>
                <div className='dm-tile__items'>
                  {g.items.map((item, j) => (
                    <span
                      key={item}
                      className='dm-tile__item'
                      style={anim({
                        at: stagger(a + 0.015, 0.014, 0.04, j),
                        y: 16,
                        s: 0.8
                      })}
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </article>
            </div>
          )
        })}
      </div>
    </div>
  )
}
